module.exports = __webpack_public_path__ + "093ee89.ttf";